import * as axiosService from "../axiosService";



export const CheckDriverExist = (payload) => {
    const queryParams = [];

    if (payload.countryCode) {
        queryParams.push(`countryCode=${payload.countryCode}`);
    }
    if (payload.mobileNumber) {
        queryParams.push(`mobileNumber=${payload.mobileNumber}`);
    }
    if (payload.supplierId) {
        queryParams.push(`supplierId=${payload.supplierId}`);
    }

    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/CheckUserExistsForSaveDriver${queryString}`);
};


//saveDriver
export const addDriverOnboard = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Driver/SaveDriver`, payload);
};


export const addDriverInFleet = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/AddDriverInFleet`, payload);
};


export const getDriverById = (driverId) => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Driver/GetDriver?driverID=${driverId}`);
};


export const getAllDriver = (payload) => {
    const queryParams = [];

    if (payload.searchText) {
        queryParams.push(`searchText=${payload.searchText}`);
    }
    if (payload.pageNumber) {
        queryParams.push(`pageNumber=${payload.pageNumber}`);
    }
    if (payload.pageSize) {
        queryParams.push(`pageSize=${payload.pageSize}`);
    }
    if (payload.sortBy) {
        queryParams.push(`sortBy=${payload.sortBy}`);
    }
    if (payload.sortOrder) {
        queryParams.push(`sortOrder=${payload.sortOrder}`);
    }
    if (payload.status) {
        queryParams.push(`status=${payload.status}`);
    }
    if (payload.supplierId) {
        queryParams.push(`supplierId=${payload.supplierId}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/GetFleetDriverList${queryString}`)
};


export const getDriverDetails = (driverId,supplierId) => {
    const queryParams = [];

    if (driverId) {
        queryParams.push(`externalDriverId=${driverId}`);
    }
    if (supplierId) {
        queryParams.push(`supplierId=${supplierId}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/GetFleetDriverDetail${queryString}`);
};


export const RemoveDriverFromFleet = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/RemoveDriverFromFleet`, payload);
};


export const verifyDriverMobile = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/VerifyUserMobileNumber`, payload);
};

export const driverProfilePicUpload = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Driver/UploadDriverProfilePicture`, payload);
};

